export default __webpack_public_path__ + "static/media/1.07d16ef7.jpg";